/**
 * Modelo para la información del propietario en el lead
 */
export interface LeadResumeOwner {
  firstName: string;
  secondName: string;
  lastName: string;
  secondLastName: string | null;
  documentType: string;
  documentNumber: string;
  expeditionDate: string;
  mail: string;
  mobilePhone: string;
  productCode: string | null;
}

/**
 * Modelo para la información de la propiedad
 */
export interface LeadResumeProperty {
  RentalFee: number;
  AdministrationValue: number;
  Department: string;
  CityProperty: string;
  CityCode: string;
  DepartmentCode: string;
  Code: string;
  UseProperty: string;
  PropertyAddress: string;
  RealEstateLicensePlate: string;
  TemporaryContracted: string;
  ContractEndDate: string;
  ContractStartDate: string;
}

/**
 * Modelo para la información del inquilino
 */
export interface LeadResumeTenant {
  FirstName?: string;
  DocumentType: string;
  DocumentNumber: string;
  Mail?: string;
}

/**
 * Modelo para la configuración de datos del producto
 */
export interface ProductsConfigurationData {
  FirstName: string;
  SecondName: string | null;
  LastName: string;
  SecondLastName: string | null;
  DocumentType: string;
  DocumentNumber: string;
  ExpeditionDate: string;
  Mail: string;
  MobilePhone: string;
  ProductCode: string | null;
  Property: LeadResumeProperty;
  Tenant: LeadResumeTenant;
  leadId?: string;
}

/**
 * Modelo principal para el response del orquestador de lead resume
 */
export interface LeadResumeResponse {
  data: {
    productsconfigurationdataarriendos: ProductsConfigurationData;
  };
}

/**
 * Modelo para el request al orquestador
 */
export interface LeadResumeRequest {
  getRetakeData: boolean;
  recordId: string;
  productCategory: string;
}

/**
 * Enum para los estados del lead resume
 */
export enum LeadResumeStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

/**
 * Modelo para el estado del lead resume en la aplicación
 */
export interface LeadResumeState {
  status: LeadResumeStatus;
  data: LeadResumeResponse | null;
  error: string | null;
  lastUpdated: Date | null;
}
